const onRevoke = (): void => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('consent', 'revoke');
  }
};

export default onRevoke;
